export const environment = {
  production: false,
  apiUrl: 'https://dev-back.mysportapp.co/api',
  /** VAPID public key for web push notifications. */
  vapidKey: '',
  /** Web domain used by Universal Links / App Links for deep linking. */
  webDomain: 'https://dev.mysportapp.co',
};
